export const warningSeverity = {
  cwsvIgnore: 0,
  cwsvLow: 1,
  cwsvMedium: 2,
  cwsvHigh: 3,
  cwsvFatal: 4,
  cwsvCalculatedFatal: 5,
};

export const warningSeverityCaption = {
  [warningSeverity.cwsvIgnore]: 'Info',
  [warningSeverity.cwsvLow]: 'Info',
  [warningSeverity.cwsvMedium]: 'Warning',
  [warningSeverity.cwsvHigh]: 'Warning',
  [warningSeverity.cwsvFatal]: 'Error',
  [warningSeverity.cwsvCalculatedFatal]: 'Error',
};

export const warningId = {
  cwrnValidation: -5,
  cwrnAdmin: -4,

  cwrnUserSetPanelMeasurements: 1,
  cwrnUserSetEdgeDetails: 2,
  cwrnEdgeLengthNegative: 3,
  cwrnBaseSlopesInvalid: 4,
  cwrnBaseWidthsInvalid: 5,
  cwrnHeadSlopesInvalid: 6,

  cwrnPanelThinForBracket: 11,
  cwrnPanelThickForBracket: 12,
  cwrnPanelThinForHinge: 13,
  cwrnPanelThickForHinge: 14,
  cwrnPanelThinForHandle: 15,
  cwrnPanelThickForHandle: 16,
  cwrnPanelThinForFitting: 17,
  cwrnPanelThickForFitting: 18,

  cwrnGlassDoorRequiresHeadSupport: 21,
  cwrnMeasureMethodOverridden: 22,
  cwrnDoorHingedOffRake: 23,
  cwrnDoorHingedOffOddAngle: 24,
  cwrnDoorHingedOverlapping90Nib: 25,
  cwrnDoorHingedInvalidNibHeight: 26,
  cwrnDoorWallPivotOnLeaningWall: 27,
  cwrnDoorNotInlineWithSidelite: 28,

  cwrnNoBracketsForCeiling: 31,
  cwrnNoChannelForCeiling: 32,
  cwrnNoHeaderForCeiling: 33,
  cwrnNoSupportBarForCeiling: 34,
  cwrnBaseAnotherClamp: 36,
  cwrnBaseChannelOr2Clamps: 37,
  cwrnBaseChannelOr1Clamp: 38,
  cwrnHeadAnotherClamp: 39,
  cwrnHead2Clamps: 40,
  cwrnHead1Clamp: 41,
  cwrnSideChannelOrClamp: 42,
  cwrnFixedTransomClamps: 43,
  cwrnCentreSwivelClamps: 44,
  cwrnFixedWithSwivelClamps: 45,

  cwrnHingeInappropriate: 51,
  cwrnNoHinges: 52,
  cwrnHinge1SideNeed3: 53,
  cwrnHinge1SideNeed2: 54,
  cwrnHinge1PivotNeed2: 55,
  cwrnHingeMissingTop: 56,
  cwrnHingeMissingBottom: 57,
  cwrnHingeMaxWidth: 58,
  cwrnHingeMaxWidthFor2: 59,

  cwrnHingeMaxWeightFor2: 62,
  cwrnHingeMaxWeightFor3: 63,
  cwrnHingeMaxWeightForPivots: 64,
  cwrnMultipleCLChangesWithCorner: 65, // This is shower version, warning id 234 is shopfront version.
  cwrnHingingOffElbow: 66,
  cwrnHingeClearanceConflicts: 67, // Similar to cwrnTopClearanceConflicts, but for hinges.

  cwrnNoHandle: 71,
  cwrnHandleTooWide: 72,
  cwrnHandleCloseToEdge: 73,
  cwrnHandleHasNoHoles: 74,

  cwrnUnusedFittings: 81,
  cwrnUnsetColour: 82,
  cwrnMissingRequiredFittings: 83, // General shower warning for missing required fittings.

  cwrnHoleTooCloseToEdge: 91,
  //cwrnHoleTooCloseToCorner: 92, // T2054 20091001 Not used!!!
  cwrnHoleTooSmallForGlass: 93,

  //handicap warnings
  // XXX T2054 20091001 None of these are used!!!
  cwrnFittingIntrudesOnOpening: 101,
  cwrnDoorNarrow: 102,
  cwrnUninteruptedSurface: 103,
  cwrnFittingNotAccesible: 104,
  cwrnBottomOpeningWidth: 105,
  cwrnTopOpeningWidth: 106,

  cwrnFinOffsetUnusual: 110,
  cwrnDoorwayHeight: 111, // XXX T2054 20091001 Not used!!!
  //cwrnSideliteTooWide: 112, // Replaced with setting 170
  cwrnTooHeavyForTopCloser: 113, // XXX T2054 20091001 Not used!!!
  cwrnNarrowFabricatedPanel: 114,
  cwrnMaxDoorHeight: 115, // XXX T2054 20091001 Not used!!!
  cwrnDoorWide: 116, // XXX T2054 20091001 Not used!!!
  cwrnDisplayDoorOnly: 117, // XXX T2054 20091001 Not used!!!
  cwrnDoorWidthPatch: 118, // XXX T2054 20091001 Not used!!!
  cwrnTooNarrowForCloser: 119,

  cwrnDoorNoLock: 121, // XXX T2054 20091001 Not used!!!
  cwrnTopLock: 122, // XXX T2054 20091001 Not used!!!
  cwrnLockGapTooBig: 123, // XXX T2054 20091001 Not used!!!

  cwrnNarrowHeaderPanicHandle: 131, // XXX T2054 20091001 Not used!!!
  cwrnPanicHandleTooLong: 132, // XXX T2054 20091001 Not used!!!
  cwrnStrikeKeeper: 133, // XXX T2054 20091001 Not used!!!
  cwrnUnknownHardware: 134,
  cwrnFinRecommended: 135,
  cwrnFinPosition: 136,

  cwrnDadeCounty: 141, // XXX T2054 20091001 Not used!!!

  // 20050826 FPS was cwrnDoorHeavy.
  // Recycled for CRL GANA rules implementation since it wasn't being used
  // anywhere and didn't exist in any D.B.
  cwrnDoorTooHeavy: 151,
  cwrnTransomHeavy: 152, // XXX T2054 20091001 Not used!!!

  cwrnSpindleGapTooSmall: 161,
  cwrnSpindleGapTooBig: 162,
  cwrnPivotOffsetTooSmall: 163, // XXX T2054 20091001 Not used!!!

  cwrnDoorTooTall: 170,
  cwrnDoorTooWide: 171,
  cwrnSideliteTooTall: 172,
  cwrnSideliteTooWide: 173, //112
  cwrnTransomTooTall: 174,
  cwrnTransomTooWide: 175,
  cwrnTransomTooWideForClamp: 176,
  cwrnTransomTooTallForClamp: 177,
  cwrnGlassOrdered: 178,
  cwrnHardwareOrdered: 179,

  cwrnCableExcessiveTurn: 181,
  cwrnCableBranches: 182,
  cwrnCableSupportRequired: 183,
  cwrnCableInfillTooLong: 184,

  cwrnInfillTooWideC2C: 186, // C2C width. Doesn't have to be glass.
  cwrnGlassInfillTooTall: 187,
  cwrnGlassInfillTooLarge: 188, // Ie if it exceeds maximum glass area.

  cwrnBottomRailToLow: 190, // highest ground is above bottom rail
  cwrnSectionGlassDetails: 191,
  cwrnRailingGlassDetails: 192,
  cwrnSectionHeightBelowUsageMin: 193,
  cwrnSectionHeightAboveUsageMax: 194,

  cwrnStairNoHeight: 200,
  // T1771 New warnings for sliding door kit
  cwrnSlidingDoorKitInappropriate: 201,
  cwrnSlidingDoorUnsuportedConfiguration: 202,
  cwrnSlidingDoorKitTooShort: 203,
  cwrnSlidingDoorPositionInvalid: 204, // T3392 Shopfronts use.
  cwrnSlidingDoorFixedPanelNonStandard: 205,
  cwrnSlidingDoorHasHeadSlope: 206,
  cwrnSlidingDoorHasBaseSlope: 207,
  cwrnSlidingDoorNoKitOrTrack: 208,
  cwrnSlidingDoorKitOverriddenHardware: 209,
  cwrnSlidingDoorInnerDoorClosesAgainstFixed: 210,
  cwrnSlidingDoorMissingGlassConnectors: 211,
  cwrnSlidingDoorMissingWallConnectors: 212,
  cwrnSlidingDoorMissingHangers: 213,
  cwrnSlidingDoorMissingGuide: 214,
  cwrnSlidingDoorHandleBothSliding: 215, // DEPRECATE???
  cwrnSlidingDoorTooHeavy: 216, // T3392 Shopfronts use. Should really just use generic DoorTooHeavy warning
  cwrnSlidingDoorKitTooNarrow: 217,
  cwrnSlidingDoorTrackInnerOuterDoorway: 218, // T3392 Shopfronts use.
  cwrnSlidingDoorKitWrongFixedPanelThickness: 219, // Cottage only.

  // Glass stock panels
  cwrnStockPanelUsed: 220,
  cwrnStockPanelIncorrectSize: 221,
  cwrnStockPanelInappropriate: 222,
  cwrnStockPanelWrongShape: 223,
  cwrnStockPanelHardwareMissing: 224,

  cwrnChannelNotRecessedWhenRequired: 230,
  cwrnTowelRailCouldHitWall: 231,
  cwrnPanelTooSmallToBeFabricated: 232,
  cwrnSlidingDoorMayNotFullyOpen: 233, // T3392
  cwrnMultipleCLChangesWithCornerSF: 234, // T3392 Similar to warning id 65, but for shopfront sliding doors.
  cwrnSlidingDoorTooWide: 235,
  cwrnSlidingDoorTrackInappropriate: 236,
  cwrnSlidingPocketCoverageTooSmall: 237,

  cwrnGateTooBigForHinges: 240,
  // Panel width warnings constants
  cwrnMaxWidthPanelHandleSide: 241,
  cwrnMaxWidthPanelHingeSide: 242,
  cwrnMinWidthPanelHingeSide: 243,
  cwrnDoorwayStyleNotAssigned: 244,
  cwrnCableTooLongForCableKit: 245,
  cwrnFasciaRequiresDoublePost: 246,
  cwrnPanelAdjacentToNib: 247,
  cwrnCableKitHasCorner: 248,
  cwrnPivotOffsetAlongTooBigForDoor: 249,
  cwrnPivotOffsetAlongTooSmallForDoor: 250,
  cwrnFittingDontMatchPivotOffset: 251,

  cwrnMissingSectionGuardRail: 253,
  cwrnSectionGuardRailTooLow: 254,
  cwrnMissingSectionGripRail: 255,
  cwrnSectionGripRailTooHigh: 256,
  cwrnSectionGripRailTooLow: 257,
  cwrnSectionTopRailTooLowAtWallJoint: 258,
  cwrnMissingWallForSmallBalustrade: 259,
  cwrnGripRailOffsetTooSmall: 260,
  cwrnNonCircularExtrusionComplexMitre: 261,
  cwrnBadHingeForBalustradeGate: 262,
  cwrnBadHandleForBalustradeGate: 263,
  cwrnFittingDontMatchGatePivotOffset: 264, //needed instead of 251 as that mentions doors and panels.
  cwrnNotEnoughShelfGlassBrackets: 265,
  cwrnNotEnoughShelfWallBrackets: 266,
  cwrnOverheadSupportBarTooShort: 267,
  cwrnCornerSupportBarTooShort: 268,
  cwrnInvalidHeaderFreeShower: 269,
  cwrnCloserAngleTooLarge: 270, // Regardless of handle chosen.
  cwrnPivotPointBackToBackDoor: 271, // Regardless of handle chosen.
  cwrnHorizHandleFrameRequiredAdjustments: 272, // Horiz handle requires a certain pivot point and/or inset. EG: CRL ACH handles.
  cwrnHorizHandleWithFrame: 273, // General warning if no required adjustments and there is a horiz handle on the door, with a frame/wall on the pivot edge.
  cwrnHandicapAccessDoorTooNarrow: 274,
  cwrnACHNonDummyCustomHandle: 275,
  cwrnACHDeadboltStockHandle: 276,
  cwrnFittingCustomNameMissing: 277,
  cwrnOperableTransomClamps: 278,
  cwrnHingeFixedPanelWidth: 279,
  cwrnHingeFixedPanelHeight: 280,
  cwrnHingeFixedPanelThickness: 281,
  cwrnHingeFixedPanelWidthWithAlternative: 282,
  cwrnHingeFixedPanelHeightWithAlternative: 283,
  cwrnGlassToGlassBracketsMissing: 284,

  cwrnCloserMaxDoorWeight: 288,
  cwrnCloserMaxDoorWidth: 289,
  cwrnGateMinimumBottomClearance: 290,
  cwrnTopClearanceConflicts: 291,
  cwrnDoorwayTooNarrow: 292,
  cwrnDoorwayTooWide: 293,
  cwrnDoorwayTooShort: 294,
  cwrnDoorwayTooTall: 295,

  cwrnInvalidSlidingBiFoldConfiguration: 300,
  cwrnInvalidSlidingBiFoldDoorWidth: 301,
  cwrnSlidingBiFoldSideHinges: 302,
  cwrnInvalidSunshadeInfillWidth: 305,
  cwrnSideliteTooHeavy: 306,
  cwrnSideliteTooTallWithRecommendation: 307,
  cwrnSideliteTooWideWithRecommendation: 308,
  cwrnSideliteTooHeavyWithRecommendation: 309,
  cwrnGateUnattached: 310,
  cwrnVerticalMetalThickerThanRails: 311, // T4411 Vertical frame thicker than rails.
  cwrnCustomFittingClearanceDefault: 312,
  cwrnFirstSlideIntoWidthTooSmall: 313,

  cwrnOverheadTSupportBarTooShort: 314,

  cwrnSlidingTrackExceedMaximumWidthNoTransom: 315,
  cwrnSlidingTrackExceedMaximumHeightNoTransom: 316,
  cwrnDryPackingRequired: 319,

  cwrnSlidingDoorTopGuideNoWallOnHandleSide: 320,

  cwrnRuleInvalidFitting: 321,
  cwrnRuleInvalidGlass: 322,

  cwrnIncompatableChannelWithSil: 323,
  cwrnMissingBaseChannelForSlidingDoorController: 324,
  cwrnInvalidHeaderlessSlidingDoor: 325,
  cwrnSideliteFrameTooWide: 326,
  cwrnSideliteFrameTooTall: 327,

  cwrnDoorwayCustomFabrication: 330,
  cwrnFramedGlassSize: 331,
  cwrnElevationExceedsRecommendedWidth: 332,
  cwrnElevationExceedsMaxWidth: 333,

  cwrnGlassRestriction: 335,
  cwrnInvalidGlassDimensions: 336,
  cwrnDoorTooHeavyForDoorStops: 337,
  cwrnDoorTooNarrow: 338,
  cwrnSlideSideWidthTooSmall: 339,
  cwrnTransomRequireAdditionalSupport: 340,
  cwrnSlidingDoorTooNarrowForHangers: 341,
  cwrnSlidingDoorOpeningTooNarrow: 342,
  cwrnStrictSmallPanelModeIssues: 343,
  cwrnNonStockPanelUsedInStockSection: 344,
  cwrnNoKeeperPatchForLockPatch: 345,
  cwrnPartialHeightPostTooHigh: 346,
  cwrnUserOverriddenGlassProduct: 347,

  cwrnSideliteDLOTooWide: 348,
  cwrnSideliteDLOTooTall: 349,
  cwrnElevationExceedsRecommendedHeight: 350,
  cwrnElevationExceedsMaxHeight: 351,
  cwrnCutRunExceedsWindloadMaxHeight: 352,

  cwrnUnsupportedOffsetSectionAdjacentToCurves: 353,
  cwrnJointWithNoCommonPoint: 354,
  cwrnNoInlineInstallationCapableCompensator: 355,

  cwrnProcessRuleTooClose: 356,

  cwrnCableDirectionConfigurationInvalid: 360,
  cwrnDefaultWindloadChanged: 361,

  cwrnWindowTooNarrow: 362,
  cwrnWindowTooWide: 363,
  cwrnWindowTooShort: 364,
  cwrnWindowTooTall: 365,
  cwrnWindowStyleNotAssigned: 366,
  cwrnAdjacentLeavesIncompatible: 368,
  cwrnUnsupportedWindowConfiguration: 369,

  cwrnLadderPullTooHigh: 370,
  cwrnLadderPullTooLow: 371,
  cwrnLadderPullTooCloseToRail: 372,

  cwrnMultipleCornerCutoutsOnSameCorner: 373,
  cwrnPivotCustomPositioned: 374,
  cwrnPivotPointMismatch: 375,
  cwrnFittingsIntersect: 376,

  cwrnDimensionOutageTooLarge: 377,
  cwrnFramedDoorUsingCustomGlass: 378,
};
